import * as yup from 'yup';

export const validation = yup.object().shape({
    name: yup.string().required('必須項目です'),
    note: yup.string().required('必須項目です'),
    is_agree_additional: yup.boolean().required('必須項目です').oneOf([true], "必須項目です")
});
